import Vue from 'vue'
import Router from 'vue-router'
import ServiceLibrary from '@/views/ServiceLibrary'
import USBForm from '@/views/USBForm'
import ImplicitCallback from '@/components/ImplicitCallback'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'ServiceLibrary',
      path: '/',
      component: ServiceLibrary,
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'USBForm',
      path: '/usb',
      component: USBForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'Error',
      path: '/error',
      component: () => import('@/views/ErrorLandingPage')
    },
    {
      path: '/implicit/callback',
      component: ImplicitCallback
    },
    {path: '*', redirect: '/'}
  ]
})

export default router
